import React, {createContext, FC, ReactNode, useCallback, useContext, useState} from "react";

type LastUpdatedContextType = {
    lastUpdated: Date | null;
    setLastUpdated: (date: Date) => void;
};

const LastUpdatedContext = createContext<LastUpdatedContextType>({
    lastUpdated: null,
    setLastUpdated: () => {},
});

export const useLastUpdated = (): LastUpdatedContextType => useContext(LastUpdatedContext);

type LastUpdatedProviderProps = {
    children: ReactNode;
};

export const LastUpdatedProvider: FC<LastUpdatedProviderProps> = ({children}) => {
    const [lastUpdated, setLastUpdatedState] = useState<Date | null>(null);

    const setLastUpdated = useCallback((date: Date) => {
        setLastUpdatedState(date);
    }, []);

    return (
        <LastUpdatedContext.Provider value={{lastUpdated, setLastUpdated}}>
            {children}
        </LastUpdatedContext.Provider>
    );
};
